import { usePacketBase } from '../Contexts/PacketBaseContext';
import { WithTooltip } from '../../../components/WithTooltip';
import { Dropdown } from './Dropdown';
import languages from '../../../../public/json/languages.json';
import readingLevels from '../../../../public/json/reading-levels.json';
import { BookOpenIcon, LanguageIcon } from '@heroicons/react/24/outline';
import { AcademicCapIcon } from '@heroicons/react/24/outline';
import { useHomepageModals } from '../Contexts/HomepageModalsContext';
import { getCategorizedSubjects } from '../../../utils/skills';
import { useContext } from 'react';
import { DiffitUserContext } from '../../../contexts/DiffitUserContext';
import { useUser } from '@clerk/react';
import CustomerIOPlaceholder from '../../../components/CustomerIOPlaceholder';

export const ResourceSettings = () => {
  const { language, setLanguage, readingLevel, setReadingLevel } = usePacketBase();
  const { setAlignToTypeClicked } = useHomepageModals();
  const { diffitUser } = useContext(DiffitUserContext);
  const { user } = useUser();
  const isLoggedIn = !!user;

  const categorizedSubjects = getCategorizedSubjects(diffitUser, isLoggedIn);
  return (
    <div className=' flex flex-col sm:flex-row sm:gap-x-2 w-full sm:w-auto'>
      <SmallScreenDivider />
      <SettingDropdown
        name='Language'
        optionList={languages}
        selected={language}
        setSelected={(newLanguage) => {
          setLanguage(newLanguage);
        }}
        Icon={LanguageIcon}
        tooltipText='Language'
      />
      <SmallScreenDivider />
      <SettingDropdown
        name='Reading Level'
        optionList={readingLevels}
        selected={readingLevel}
        setSelected={(newReadingLevel) => {
          setReadingLevel(newReadingLevel);
        }}
        Icon={BookOpenIcon}
        tooltipText='Reading Level'
      />
      <SmallScreenDivider />
      <SettingDropdown
        name='Align to'
        optionList={categorizedSubjects}
        selected={'Align to...'}
        setSelected={(item) => {
          // Skip if it's a category header
          if (item?.isCategory) return;

          const subjectKey = item?.value ?? item; // Dropdown returns the full item
          // Persist the selected subject only
          localStorage.setItem('skills::selectedSubject', subjectKey);
          // Do NOT persist overrides to localStorage; the modal will apply temporary overrides
          // based on SUBJECT_MAP[subjectKey]?.setOverride without wiping user's saved state
          setAlignToTypeClicked(true);
        }}
        Icon={AcademicCapIcon}
        tooltipText='Skills & Standards'
      />
      <CustomerIOPlaceholder id='customerio-align-to' className='hidden sm:block' />
    </div>
  );
};

export const SmallScreenDivider = () => {
  return <div className='border-t border-gray-200 my-1 -mx-4 sm:hidden' />;
};

export const SettingDropdown = ({ name, optionList, selected, setSelected, Icon, tooltipText }) => {
  return (
    <WithTooltip
      position='top'
      anchor='center'
      showArrow={true}
      text={tooltipText}
      closeOnClick={true}>
      <Dropdown
        name={name}
        optionList={optionList}
        selected={selected}
        setSelected={setSelected}
        Icon={Icon}
        disablePremiumRows={false}
      />
    </WithTooltip>
  );
};
